import React from "react";

const S = {
  wrapper: { marginTop:'10px', marginLeft:'0px', border:'3px', padding:'40px', borderStyle:'solid', borderColor:'grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 1 — Circle Anatomy
// ─────────────────────────────────────────────────────────────────
function DiagramCircleAnatomy() {
  const W = 560, H = 310, cx = 175, cy = 160, R = 115;
  const deg = d => d * Math.PI / 180;

  const chordA = [cx + R*Math.cos(deg(130)), cy - R*Math.sin(deg(130))];
  const chordB = [cx + R*Math.cos(deg(30)),  cy - R*Math.sin(deg(30))];
  const arcA   = [cx + R*Math.cos(deg(200)), cy - R*Math.sin(deg(200))];
  const arcB   = [cx + R*Math.cos(deg(310)), cy - R*Math.sin(deg(310))];
  const tanPt  = [cx + R*Math.cos(deg(60)),  cy - R*Math.sin(deg(60))];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Circle Anatomy — Every Key Feature Labeled</div>
      <div style={{ textAlign:'center' }}>
        <svg width={W} height={H} viewBox={"0 0 "+W+" "+H} style={{ maxWidth:'100%' }}>
          <defs>
            <marker id="cAn" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto"><polygon points="0 0,7 3.5,0 7" fill="#1F3864"/></marker>
          </defs>

          {/* Circle */}
          <circle cx={cx} cy={cy} r={R} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="2.5"/>

          {/* Diameter */}
          <line x1={cx-R} y1={cy} x2={cx+R} y2={cy} stroke="#1F3864" strokeWidth="2" strokeDasharray="6,3"/>
          <text x={cx} y={cy-6} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">diameter d = 2r</text>

          {/* Radius */}
          <line x1={cx} y1={cy} x2={cx+R*Math.cos(deg(55))} y2={cy-R*Math.sin(deg(55))} stroke="#2E75B6" strokeWidth="2.2"/>
          <text x={cx+32} y={cy-50} fontSize="11" fill="#2E75B6" fontWeight="700">radius r</text>

          {/* Center */}
          <circle cx={cx} cy={cy} r={5} fill="#1F3864"/>
          <text x={cx+8} y={cy+15} fontSize="11" fill="#1F3864" fontWeight="700">center (h, k)</text>

          {/* Chord */}
          <line x1={chordA[0]} y1={chordA[1]} x2={chordB[0]} y2={chordB[1]} stroke="#c0392b" strokeWidth="2"/>
          <circle cx={chordA[0]} cy={chordA[1]} r={4} fill="#c0392b"/>
          <circle cx={chordB[0]} cy={chordB[1]} r={4} fill="#c0392b"/>
          <text x={chordA[0]-8} y={chordA[1]-9} textAnchor="end" fontSize="11" fill="#c0392b" fontWeight="700">chord</text>

          {/* Arc */}
          <path d={"M "+arcA[0]+","+arcA[1]+" A "+R+" "+R+" 0 0 1 "+arcB[0]+","+arcB[1]} fill="none" stroke="#27ae60" strokeWidth="3.5"/>
          <text x={cx-10} y={cy+R+22} fontSize="11" fill="#27ae60" fontWeight="700">arc  s = rθ</text>

          {/* Sector */}
          <path d={"M "+cx+","+cy+" L "+(cx+R*Math.cos(deg(200)))+","+(cy-R*Math.sin(deg(200)))+" A "+R+" "+R+" 0 0 1 "+(cx+R*Math.cos(deg(310)))+","+(cy-R*Math.sin(deg(310)))+" Z"} fill="#27ae60" fillOpacity="0.15" stroke="#27ae60" strokeWidth="1" strokeDasharray="4,3"/>
          <text x={cx-68} y={cy+70} fontSize="10" fill="#27ae60">sector</text>
          <text x={cx-70} y={cy+83} fontSize="9"  fill="#27ae60">A = r²θ/2</text>

          {/* Tangent — label pushed up and left so it doesn't run off edge */}
          {(() => {
            const tx = tanPt[0], ty = tanPt[1];
            const normX = Math.cos(deg(60)), normY = -Math.sin(deg(60));
            const tanX = -normY, tanY = normX;
            const tlen = 52;
            const s = 10;
            return (
              <g>
                <line x1={tx - tanX*tlen} y1={ty - tanY*tlen} x2={tx + tanX*tlen} y2={ty + tanY*tlen} stroke="#9b59b6" strokeWidth="2"/>
                <line x1={cx} y1={cy} x2={tx} y2={ty} stroke="#9b59b6" strokeWidth="1.3" strokeDasharray="4,3"/>
                <polyline points={(tx+tanX*s-normX*s)+","+(ty+tanY*s-normY*s)+" "+(tx-normX*s)+","+(ty-normY*s)+" "+(tx-normX*s+tanX*s)+","+(ty-normY*s+tanY*s)} fill="none" stroke="#9b59b6" strokeWidth="1.3"/>
                {/* Label above tangent end, not to the right */}
                <text x={tx + tanX*tlen - 10} y={ty + tanY*tlen - 14} textAnchor="end" fontSize="11" fill="#9b59b6" fontWeight="700">tangent</text>
                <text x={tx + tanX*tlen - 10} y={ty + tanY*tlen - 2} textAnchor="end" fontSize="9" fill="#9b59b6">perp. to radius</text>
              </g>
            );
          })()}

          {/* C= A= moved to safe left zone */}
          <text x={cx-R-10} y={cy-40} textAnchor="end" fontSize="10" fill="#2E75B6">C = 2πr</text>
          <text x={cx-R-10} y={cy-26} textAnchor="end" fontSize="10" fill="#2E75B6">A = πr²</text>

          {/* Info panel — right column, clear of circle */}
          <rect x={310} y={10} width={240} height={145} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={430} y={27} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">Key Formulas</text>
          {[
            ['Circumference:','C = 2πr = πd','#2E75B6'],
            ['Area:',         'A = πr²',      '#2E75B6'],
            ['Arc length:',   's = rθ  (θ in radians)','#27ae60'],
            ['Sector area:',  'A = r²θ/2',   '#27ae60'],
            ['Chord length:', '2r·sin(θ/2)', '#c0392b'],
          ].map(([lbl,val,col],i)=>(
            <g key={i}>
              <text x={320} y={44+i*22} fontSize="9" fill="#888" fontFamily="'Courier New',monospace">{lbl}</text>
              <text x={320} y={57+i*22} fontSize="10" fill={col} fontFamily="'Courier New',monospace" fontWeight="700">{val}</text>
            </g>
          ))}
        </svg>
      </div>
      <div style={S.dCaption}>
        A circle is the set of all points equidistant from the center. Every geometric feature — chord, arc, sector, tangent — has a clean formula relating it to the radius r and a central angle θ (in radians).
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 2 — Circle Equations
// ─────────────────────────────────────────────────────────────────
function DiagramCircleEquations() {
  const W = 580, H = 270, cx = 160, cy = 150, R = 90;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Circle Equations — Standard Form, General Form, and Completing the Square</div>
      <div style={{ textAlign:'center' }}>
        <svg width={W} height={H} viewBox={"0 0 "+W+" "+H} style={{ maxWidth:'100%' }}>
          {/* Grid */}
          {[-3,-2,-1,0,1,2,3,4,5].map(v=>(
            <g key={v}>
              <line x1={cx+v*30} y1={20} x2={cx+v*30} y2={H-20} stroke="#eee" strokeWidth="1"/>
              <line x1={20} y1={cy-v*30} x2={W/2+40} y2={cy-v*30} stroke="#eee" strokeWidth="1"/>
            </g>
          ))}
          {/* Axes */}
          <line x1={20} y1={cy} x2={W/2+30} y2={cy} stroke="#1F3864" strokeWidth="1.4"/>
          <line x1={cx} y1={H-20} x2={cx} y2={20} stroke="#1F3864" strokeWidth="1.4"/>
          <text x={W/2+32} y={cy+4} fontSize="10" fill="#1F3864" fontWeight="700">x</text>
          <text x={cx+4} y={18} fontSize="10" fill="#1F3864" fontWeight="700">y</text>
          {[-3,-2,-1,1,2,3].map(v=>(
            <g key={v}>
              <text x={cx+v*30} y={cy+14} textAnchor="middle" fontSize="8" fill="#bbb">{v}</text>
              <text x={cx-6} y={cy-v*30+3} textAnchor="end" fontSize="8" fill="#bbb">{v}</text>
            </g>
          ))}

          {/* Circle centered at (1, -1), r=3 → 3*30=90px */}
          <circle cx={cx+30} cy={cy+30} r={R} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>

          {/* Center */}
          <circle cx={cx+30} cy={cy+30} r={5} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
          <text x={cx+30+8} y={cy+30-6} fontSize="11" fill="#e07b00" fontWeight="700">(h,k) = (1,-1)</text>

          {/* Radius arrow */}
          <line x1={cx+30} y1={cy+30} x2={cx+30+R*Math.cos(Math.PI/5)} y2={cy+30-R*Math.sin(Math.PI/5)} stroke="#2E75B6" strokeWidth="1.8"/>
          <text x={cx+30+46} y={cy+30-52} fontSize="11" fill="#2E75B6" fontWeight="700">r = 3</text>

          {/* Equation forms panel — starts at x=290, width=280, fits within W=580 */}
          <rect x={290} y={10} width={282} height={248} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={431} y={28} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">Circle Equation Forms</text>

          {/* Standard form */}
          <rect x={298} y={34} width={266} height={48} rx={4} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1.5"/>
          <text x={431} y={50} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">Standard Form</text>
          <text x={431} y={66} textAnchor="middle" fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace" fontWeight="700">{"(x-h)² + (y-k)² = r²"}</text>
          <text x={431} y={78} textAnchor="middle" fontSize="9" fill="#555">{"(x-1)² + (y+1)² = 9"}</text>

          <text x={431} y={100} textAnchor="middle" fontSize="10" fill="#888">expand and rearrange ↓</text>

          {/* General form */}
          <rect x={298} y={106} width={266} height={48} rx={4} fill="#fff0f0" stroke="#c0392b" strokeWidth="1.5"/>
          <text x={431} y={122} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">General Form</text>
          <text x={431} y={138} textAnchor="middle" fontSize="11" fill="#c0392b" fontFamily="'Courier New',monospace" fontWeight="700">{"x² + y² + Dx + Ey + F = 0"}</text>
          <text x={431} y={150} textAnchor="middle" fontSize="9" fill="#555">{"x² + y² − 2x + 2y − 7 = 0"}</text>

          <text x={431} y={172} textAnchor="middle" fontSize="10" fill="#888">complete the square ↑ to recover</text>

          {/* Completing the square steps */}
          <rect x={298} y={178} width={266} height={76} rx={4} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.3"/>
          <text x={431} y={194} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">Completing the Square</text>
          {[
            'x²−2x + y²+2y = 7',
            '(x²−2x+1) + (y²+2y+1) = 9',
            '(x−1)² + (y+1)² = 9',
            'center (1,−1),  r = sqrt(9) = 3',
          ].map((line,i)=>(
            <text key={i} x={306} y={208+i*14} fontSize="9.5" fill={i===3?'#27ae60':'#444'} fontFamily="'Courier New',monospace" fontWeight={i===3?'700':'400'}>{line}</text>
          ))}
        </svg>
      </div>
      <div style={S.dCaption}>
        Standard form immediately reveals center (h, k) and radius r. General form requires completing the square — adding (D/2)² and (E/2)² to both sides — to convert back to standard form and read off the geometry.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 3 — Degrees, Radians, Arc Length, Sector Area
// ─────────────────────────────────────────────────────────────────
function DiagramRadians() {
  const W = 520, H = 270, cx = 155, cy = 145, R = 105;
  const deg = d => d * Math.PI / 180;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Degrees, Radians, Arc Length, and Sector Area</div>
      <div style={{ textAlign:'center' }}>
        <svg width={W} height={H} viewBox={"0 0 "+W+" "+H} style={{ maxWidth:'100%' }}>
          {/* Full circle faint */}
          <circle cx={cx} cy={cy} r={R} fill="none" stroke="#ddd" strokeWidth="1.5"/>

          {/* Sector highlight — 60 degrees */}
          {(() => {
            const t1=0, t2=deg(70);
            const x1=cx+R*Math.cos(t1), y1=cy-R*Math.sin(t1);
            const x2=cx+R*Math.cos(t2), y2=cy-R*Math.sin(t2);
            return (
              <g>
                <path d={"M "+cx+","+cy+" L "+x1+","+y1+" A "+R+" "+R+" 0 0 0 "+x2+","+y2+" Z"} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="2"/>
                {/* Arc in green */}
                <path d={"M "+x1+","+y1+" A "+R+" "+R+" 0 0 0 "+x2+","+y2} fill="none" stroke="#27ae60" strokeWidth="4"/>
                {/* Theta angle arc */}
                <path d={"M "+(cx+30)+","+cy+" A 30 30 0 0 0 "+(cx+30*Math.cos(t2))+","+(cy-30*Math.sin(t2))} fill="none" stroke="#e07b00" strokeWidth="2"/>
                <text x={cx+36} y={cy-16} fontSize="12" fill="#e07b00" fontWeight="700">θ</text>
                {/* Radius labels */}
                <text x={(cx+x1)/2} y={cy+14} fontSize="10" fill="#2E75B6" fontWeight="700">r</text>
                <text x={(cx+x2)/2-10} y={(cy+y2)/2-8} fontSize="10" fill="#2E75B6" fontWeight="700">r</text>
                {/* Arc label */}
                <text x={x1+26} y={y1-20} fontSize="11" fill="#27ae60" fontWeight="700">arc s = rθ</text>
                {/* Sector area */}
                <text x={cx+20} y={cy-28} fontSize="10" fill="#2E75B6">sector</text>
                <text x={cx+20} y={cy-15} fontSize="10" fill="#2E75B6" fontFamily="'Courier New',monospace">A = r²θ/2</text>
              </g>
            );
          })()}

          {/* 1 radian illustration — arc length = radius */}
          {(() => {
            const t2 = 1; // 1 radian
            const x1=cx+R, y1=cy;
            const x2=cx+R*Math.cos(t2), y2=cy-R*Math.sin(t2);
            return (
              <g>
                <path d={"M "+x1+","+y1+" A "+R+" "+R+" 0 0 0 "+x2+","+y2} fill="none" stroke="#c0392b" strokeWidth="3" strokeDasharray="6,3"/>
                <text x={cx+R+14} y={cy-20} fontSize="10" fill="#c0392b" fontWeight="700">1 radian:</text>
                <text x={cx+R+14} y={cy-6}  fontSize="10" fill="#c0392b">arc = radius</text>
                <line x1={cx+R*Math.cos(t2)} y1={cy-R*Math.sin(t2)} x2={cx} y2={cy} stroke="#c0392b" strokeWidth="1.3" strokeDasharray="3,3"/>
              </g>
            );
          })()}

          {/* Center */}
          <circle cx={cx} cy={cy} r={4} fill="#1F3864"/>

          {/* Conversion table */}
          <rect x={W-248} y={10} width={240} height={248} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={W-128} y={26} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">Degree ↔ Radian Conversion</text>

          {/* Header row */}
          <rect x={W-242} y={30} width={228} height={18} rx={2} fill="#2E75B6"/>
          <text x={W-188} y={43} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">Degrees</text>
          <text x={W-80}  y={43} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">Radians</text>

          {[
            ['0°',   '0'],
            ['30°',  'π/6'],
            ['45°',  'π/4'],
            ['60°',  'π/3'],
            ['90°',  'π/2'],
            ['120°', '2π/3'],
            ['135°', '3π/4'],
            ['150°', '5π/6'],
            ['180°', 'π'],
            ['270°', '3π/2'],
            ['360°', '2π'],
          ].map(([d,r],i)=>(
            <g key={i}>
              <rect x={W-242} y={48+i*17} width={228} height={17} fill={i%2===0?'#f5f9ff':'#fff'}/>
              <text x={W-188} y={59+i*17} textAnchor="middle" fontSize="10" fill="#1F3864" fontFamily="'Courier New',monospace">{d}</text>
              <text x={W-80}  y={59+i*17} textAnchor="middle" fontSize="10" fill="#2E75B6" fontFamily="'Courier New',monospace" fontWeight="700">{r}</text>
            </g>
          ))}

          {/* Conversion formulas */}
          <rect x={W-242} y={239} width={228} height={18} rx={2} fill="#EBF3FB"/>
          <text x={W-128} y={251} textAnchor="middle" fontSize="9" fill="#1F3864" fontFamily="'Courier New',monospace">deg×π/180 = rad    rad×180/π = deg</text>
        </svg>
      </div>
      <div style={S.dCaption}>
        One radian is the angle that produces an arc length exactly equal to the radius. Arc length s = rθ and sector area A = r²θ/2 only work when θ is in radians — always convert before using these formulas.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 4 — Ellipse Anatomy
// ─────────────────────────────────────────────────────────────────
function DiagramEllipseAnatomy() {
  const W = 560, H = 300;
  // Shrink ellipse and shift right so info boxes don't overlap it
  const cx = 330, cy = 155;
  const a = 130, b = 82;
  const c = Math.sqrt(a*a - b*b);
  const ecc = (c/a).toFixed(3);

  const f1 = [cx - c, cy], f2 = [cx + c, cy];
  const t = 55 * Math.PI / 180;
  const px = cx + a*Math.cos(t), py = cy - b*Math.sin(t);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Ellipse Anatomy — Semi-axes, Foci, Eccentricity, and the Defining Property</div>
      <div style={{ textAlign:'center' }}>
        <svg width={W} height={H} viewBox={"0 0 "+W+" "+H} style={{ maxWidth:'100%' }}>
          <defs>
            <marker id="eArr" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto"><polygon points="0 0,7 3.5,0 7" fill="#c0392b"/></marker>
            <marker id="eArrG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto"><polygon points="0 0,7 3.5,0 7" fill="#27ae60"/></marker>
          </defs>

          {/* Ellipse */}
          <ellipse cx={cx} cy={cy} rx={a} ry={b} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="2.5"/>

          {/* Major axis */}
          <line x1={cx-a} y1={cy} x2={cx+a} y2={cy} stroke="#1F3864" strokeWidth="1.3" strokeDasharray="5,4"/>
          <text x={cx} y={cy+15} textAnchor="middle" fontSize="10" fill="#1F3864">major axis = 2a</text>

          {/* Semi-major annotation */}
          <line x1={cx} y1={cy} x2={cx+a} y2={cy} stroke="#2E75B6" strokeWidth="2.2"/>
          <text x={cx+a/2} y={cy-8} textAnchor="middle" fontSize="11" fill="#2E75B6" fontWeight="700">a = {a}</text>

          {/* Minor axis */}
          <line x1={cx} y1={cy-b} x2={cx} y2={cy+b} stroke="#1F3864" strokeWidth="1.3" strokeDasharray="5,4"/>

          {/* Semi-minor annotation */}
          <line x1={cx} y1={cy} x2={cx} y2={cy-b} stroke="#c0392b" strokeWidth="2.2"/>
          <text x={cx-36} y={cy-b/2} fontSize="11" fill="#c0392b" fontWeight="700">b = {b}</text>
          <text x={cx+5}  y={cy-b/2} fontSize="10" fill="#555">minor semi-axis</text>

          {/* Foci */}
          {[f1,f2].map(([fx,fy],i)=>(
            <g key={i}>
              <circle cx={fx} cy={fy} r={6} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
              <text x={fx} y={fy+18} textAnchor="middle" fontSize="10" fill="#e07b00" fontWeight="700">F{i+1}</text>
            </g>
          ))}
          {/* c annotation */}
          <line x1={cx} y1={cy+28} x2={f2[0]} y2={cy+28} stroke="#e07b00" strokeWidth="1.5"/>
          <line x1={cx}    y1={cy+23} x2={cx}    y2={cy+33} stroke="#e07b00" strokeWidth="1.5"/>
          <line x1={f2[0]} y1={cy+23} x2={f2[0]} y2={cy+33} stroke="#e07b00" strokeWidth="1.5"/>
          <text x={(cx+f2[0])/2} y={cy+44} textAnchor="middle" fontSize="10" fill="#e07b00" fontWeight="700">c = {c.toFixed(0)}</text>

          {/* Defining property lines */}
          <circle cx={px} cy={py} r={5} fill="#9b59b6" stroke="#fff" strokeWidth="1.5"/>
          <line x1={f1[0]} y1={f1[1]} x2={px} y2={py} stroke="#9b59b6" strokeWidth="1.8" strokeDasharray="4,3"/>
          <line x1={f2[0]} y1={f2[1]} x2={px} y2={py} stroke="#9b59b6" strokeWidth="1.8" strokeDasharray="4,3"/>
          {(() => {
            const r1 = Math.sqrt((px-f1[0])**2+(py-f1[1])**2);
            const r2 = Math.sqrt((px-f2[0])**2+(py-f2[1])**2);
            return (
              <g>
                <text x={(f1[0]+px)/2-28} y={(f1[1]+py)/2-6} fontSize="10" fill="#9b59b6" fontWeight="700">r1={r1.toFixed(0)}</text>
                <text x={(f2[0]+px)/2+4}  y={(f2[1]+py)/2-6} fontSize="10" fill="#9b59b6" fontWeight="700">r2={r2.toFixed(0)}</text>
              </g>
            );
          })()}

          {/* ── Left column info boxes — well clear of ellipse left edge at cx-a = 200 ── */}
          {/* Defining property box */}
          <rect x={8} y={10} width={190} height={100} rx={4} fill="#fff" stroke="#ccd9ea"/>
          <text x={103} y={26} textAnchor="middle" fontSize="10.5" fill="#1F3864" fontWeight="700">Defining Property</text>
          <text x={103} y={42} textAnchor="middle" fontSize="10.5" fill="#9b59b6" fontFamily="'Courier New',monospace" fontWeight="700">r1 + r2 = 2a</text>
          <text x={103} y={57} textAnchor="middle" fontSize="9" fill="#555">Sum of distances from any</text>
          <text x={103} y={70} textAnchor="middle" fontSize="9" fill="#555">point on the ellipse to both</text>
          <text x={103} y={83} textAnchor="middle" fontSize="9" fill="#555">foci is always equal to 2a</text>

          {/* Eccentricity box */}
          <rect x={8} y={118} width={190} height={68} rx={4} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
          <text x={103} y={134} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">Eccentricity  e = c/a = {ecc}</text>
          <text x={14}  y={150} fontSize="9.5" fill="#555">e = 0: circle</text>
          <text x={14}  y={164} fontSize="9.5" fill="#555">0 &lt; e &lt; 1: ellipse</text>
          <text x={14}  y={178} fontSize="9.5" fill="#555">e = 1: parabola   e &gt; 1: hyperbola</text>
        </svg>
      </div>
      <div style={S.dCaption}>
        An ellipse is the set of all points where the sum of distances to two fixed foci is constant (= 2a). When both foci merge at the center, eccentricity = 0 and the ellipse becomes a circle. Eccentricity describes how "stretched" the ellipse is.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 5 — Inscribed and Circumscribed Circles
// ─────────────────────────────────────────────────────────────────
function DiagramInscribed() {
  const W = 580, H = 330; // taller to give bottom text room

  const cx1 = 130, cy1 = 155, side = 150;
  const h = side * Math.sqrt(3)/2;
  const R_circ = side / Math.sqrt(3);
  const R_in   = side / (2*Math.sqrt(3));

  const triPts = [
    [cx1, cy1 - R_circ],
    [cx1 - side/2, cy1 - R_circ + h],
    [cx1 + side/2, cy1 - R_circ + h],
  ];

  const cx2 = 410, cy2 = 155, Rbc = 95, n = 6;
  const boltPts = Array.from({length:n},(_,i)=>[
    cx2 + Rbc*Math.cos(i*2*Math.PI/n - Math.PI/2),
    cy2 + Rbc*Math.sin(i*2*Math.PI/n - Math.PI/2),
  ]);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Inscribed and Circumscribed Circles — Incircle, Circumcircle, and Bolt Circle Patterns</div>
      <div style={{ textAlign:'center' }}>
        <svg width={W} height={H} viewBox={"0 0 "+W+" "+H} style={{ maxWidth:'100%' }}>

          {/* ── Panel 1 ── */}
          <rect x={8} y={10} width={278} height={H-20} rx={5} fill="#f8fbff" stroke="#ccd9ea"/>
          <text x={147} y={28} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">Incircle and Circumcircle</text>

          <circle cx={cx1} cy={cy1} r={R_circ} fill="none" stroke="#c0392b" strokeWidth="1.8" strokeDasharray="5,4"/>
          <circle cx={cx1} cy={cy1} r={R_in}  fill="#EBF3FB" stroke="#2E75B6" strokeWidth="2"/>
          <polygon points={triPts.map(p=>p.join(',')).join(' ')} fill="none" stroke="#1F3864" strokeWidth="2"/>
          <circle cx={cx1} cy={cy1} r={4} fill="#e07b00"/>

          <line x1={cx1} y1={cy1} x2={triPts[0][0]} y2={triPts[0][1]} stroke="#c0392b" strokeWidth="1.3" strokeDasharray="3,3"/>
          <text x={cx1+10} y={(cy1+triPts[0][1])/2} fontSize="10" fill="#c0392b" fontWeight="700">R (circumradius)</text>

          <line x1={cx1} y1={cy1} x2={cx1+R_in} y2={cy1} stroke="#2E75B6" strokeWidth="1.3" strokeDasharray="3,3"/>
          <text x={cx1+R_in/2} y={cy1-6} textAnchor="middle" fontSize="10" fill="#2E75B6" fontWeight="700">r</text>
          <text x={cx1+R_in/2} y={cy1+15} textAnchor="middle" fontSize="9" fill="#2E75B6">(inradius)</text>

          {/* Bottom labels — spread across full height with 18px gaps */}
          <text x={147} y={H-66} textAnchor="middle" fontSize="9.5" fill="#c0392b">Circumcircle: passes through all vertices</text>
          <text x={147} y={H-46} textAnchor="middle" fontSize="9.5" fill="#2E75B6">Incircle: tangent to all sides</text>
          <text x={147} y={H-26} textAnchor="middle" fontSize="9" fill="#555">Equilateral: R = 2r  (R = s/√3)</text>

          {/* ── Panel 2: Bolt circle ── */}
          <rect x={294} y={10} width={278} height={H-20} rx={5} fill="#f8fbff" stroke="#ccd9ea"/>
          <text x={433} y={28} textAnchor="middle" fontSize="11" fill="#1F3864" fontWeight="700">Bolt Circle Pattern (n = {n})</text>

          <circle cx={cx2} cy={cy2} r={Rbc} fill="none" stroke="#e07b00" strokeWidth="1.5" strokeDasharray="4,4"/>
          <circle cx={cx2} cy={cy2} r={22} fill="#ddd" stroke="#888" strokeWidth="1.5"/>
          <text x={cx2} y={cy2+4} textAnchor="middle" fontSize="9" fill="#555">bore</text>

          {boltPts.map(([bx,by],i)=>(
            <g key={i}>
              <circle cx={bx} cy={by} r={10} fill="#fff" stroke="#2E75B6" strokeWidth="1.8"/>
              <circle cx={bx} cy={by} r={4}  fill="#2E75B6"/>
              <line x1={cx2} y1={cy2} x2={bx} y2={by} stroke="#e07b00" strokeWidth="1" strokeDasharray="3,3" opacity="0.5"/>
            </g>
          ))}

          <line x1={cx2} y1={cy2} x2={boltPts[1][0]} y2={boltPts[1][1]} stroke="#e07b00" strokeWidth="1.8"/>
          <text x={(cx2+boltPts[1][0])/2+6} y={(cy2+boltPts[1][1])/2-4} fontSize="10" fill="#e07b00" fontWeight="700">BCD/2</text>

          <line x1={boltPts[0][0]} y1={boltPts[0][1]} x2={boltPts[1][0]} y2={boltPts[1][1]} stroke="#c0392b" strokeWidth="1.8" strokeDasharray="4,3"/>
          <text x={(boltPts[0][0]+boltPts[1][0])/2+12} y={(boltPts[0][1]+boltPts[1][1])/2-10} fontSize="9" fill="#c0392b" fontWeight="700">chord</text>
          <text x={(boltPts[0][0]+boltPts[1][0])/2+12} y={(boltPts[0][1]+boltPts[1][1])/2+2} fontSize="9" fill="#c0392b">= 2R·sin(π/n)</text>

          {/* Bottom labels — spread with 18px gaps */}
          <text x={433} y={H-66} textAnchor="middle" fontSize="9.5" fill="#e07b00">BCD = Bolt Circle Diameter</text>
          <text x={433} y={H-46} textAnchor="middle" fontSize="9.5" fill="#2E75B6">Bolt spacing = 360°/n = {(360/n).toFixed(0)}° apart</text>
          <text x={433} y={H-26} textAnchor="middle" fontSize="9" fill="#555">Chord = 2·(BCD/2)·sin(π/n)</text>
        </svg>
      </div>
      <div style={S.dCaption}>
        The incircle fits inside a polygon touching every side; the circumcircle passes through every vertex. Bolt circle patterns use the circumcircle concept — n bolts equally spaced on a circle of known diameter, with spacing calculated from the chord formula.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// DIAGRAM 6 — Engineering Applications
// ─────────────────────────────────────────────────────────────────
function DiagramApplications() {
  // Each panel is 140px tall (was 120), rows start at y=10 and y=160, total H=310
  const W = 520, H = 310;
  const pH = 140; // panel height
  const row2 = 160; // y-start of bottom row

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Circles and Ellipses Across Engineering Disciplines</div>
      <div style={{ textAlign:'center' }}>
        <svg width={W} height={H} viewBox={"0 0 "+W+" "+H} style={{ maxWidth:'100%' }}>

          {/* ── Civil: Pipe cross-section ── */}
          <rect x={10} y={10} width={155} height={pH} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={87} y={26} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">Civil — Pipe Flow</text>
          {(() => {
            const pcx=87, pcy=76, Ro=42, Ri=32;
            return (
              <g>
                <circle cx={pcx} cy={pcy} r={Ro} fill="#d0e8ff" stroke="#2E75B6" strokeWidth="2"/>
                <circle cx={pcx} cy={pcy} r={Ri} fill="#fff" stroke="#2E75B6" strokeWidth="1.5"/>
                <text x={pcx} y={pcy+4} textAnchor="middle" fontSize="9" fill="#2E75B6">flow</text>
                <line x1={pcx} y1={pcy} x2={pcx+Ri} y2={pcy} stroke="#2E75B6" strokeWidth="1.3" strokeDasharray="3,2"/>
                <text x={pcx+Ri/2} y={pcy-4} textAnchor="middle" fontSize="8" fill="#2E75B6">r_i</text>
                <text x={pcx+4} y={pcy+Ro-6} fontSize="8" fill="#555">A = π(Ro²-Ri²)</text>
              </g>
            );
          })()}
          <text x={87} y={10+pH-10} textAnchor="middle" fontSize="9" fill="#555">Annular cross-section area</text>

          {/* ── Aerospace: Orbit ── */}
          <rect x={175} y={10} width={155} height={pH} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={252} y={26} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">Aerospace — Orbit</text>
          {(() => {
            const ocx=252, ocy=72, oa=60, ob=38, oc=Math.sqrt(oa*oa-ob*ob);
            return (
              <g>
                <ellipse cx={ocx} cy={ocy} rx={oa} ry={ob} fill="#f0fff4" stroke="#27ae60" strokeWidth="2"/>
                <circle cx={ocx-oc} cy={ocy} r={8} fill="#2E75B6"/>
                <text x={ocx-oc} y={ocy+18} textAnchor="middle" fontSize="8" fill="#2E75B6">Earth (focus)</text>
                <circle cx={ocx+oa} cy={ocy} r={4} fill="#c0392b"/>
                <text x={ocx+oa+6} y={ocy+4} fontSize="8" fill="#c0392b">sat.</text>
                <text x={ocx-oa+4} y={ocy-ob-6} fontSize="8" fill="#555">apogee</text>
                <text x={ocx+oa-4} y={ocy-ob-6} textAnchor="end" fontSize="8" fill="#555">perigee</text>
              </g>
            );
          })()}
          <text x={252} y={10+pH-10} textAnchor="middle" fontSize="9" fill="#555">Kepler: orbits are ellipses</text>

          {/* ── Electrical: Lissajous ── */}
          <rect x={340} y={10} width={170} height={pH} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={425} y={26} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">Electrical — Lissajous</text>
          {(() => {
            const lcx=425, lcy=70, la=55, lb=34;
            const pts=[];
            for(let t=0;t<=2*Math.PI;t+=0.05){
              pts.push((lcx+la*Math.sin(t))+','+(lcy+lb*Math.sin(t+Math.PI/3)));
            }
            return (
              <g>
                <path d={"M "+pts.join(' L ')} fill="none" stroke="#9b59b6" strokeWidth="2"/>
                <line x1={lcx-la-8} y1={lcy} x2={lcx+la+8} y2={lcy} stroke="#ddd" strokeWidth="1"/>
                <line x1={lcx} y1={lcy-lb-8} x2={lcx} y2={lcy+lb+8} stroke="#ddd" strokeWidth="1"/>
                <text x={lcx} y={lcy+lb+16} textAnchor="middle" fontSize="8" fill="#9b59b6">phase diff = 60°</text>
              </g>
            );
          })()}
          <text x={425} y={10+pH-10} textAnchor="middle" fontSize="9" fill="#555">Two sinusoids → ellipse on CRO</text>

          {/* ── Structural: Mohr's circle ── */}
          <rect x={10} y={row2} width={155} height={pH} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={87} y={row2+16} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">Structural — Mohr's Circle</text>
          {(() => {
            const mcx=87, mcy=row2+68, mR=42;
            return (
              <g>
                <circle cx={mcx} cy={mcy} r={mR} fill="#fff7ee" stroke="#e07b00" strokeWidth="2"/>
                <line x1={mcx-mR-10} y1={mcy} x2={mcx+mR+10} y2={mcy} stroke="#1F3864" strokeWidth="1.2"/>
                <line x1={mcx} y1={mcy+mR+6} x2={mcx} y2={mcy-mR-6} stroke="#1F3864" strokeWidth="1.2"/>
                <circle cx={mcx+mR} cy={mcy} r={4} fill="#e07b00"/>
                <circle cx={mcx-mR} cy={mcy} r={4} fill="#e07b00"/>
                <text x={mcx+mR+5} y={mcy-6} fontSize="8" fill="#e07b00">σ_max</text>
                <text x={mcx-mR-5} y={mcy-6} textAnchor="end" fontSize="8" fill="#e07b00">σ_min</text>
                <text x={mcx} y={mcy-mR+10} textAnchor="middle" fontSize="8" fill="#c0392b">τ_max</text>
              </g>
            );
          })()}
          <text x={87} y={row2+pH-10} textAnchor="middle" fontSize="9" fill="#555">Principal stresses from circle</text>

          {/* ── Optical: Elliptical reflector ── */}
          <rect x={175} y={row2} width={155} height={pH} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={252} y={row2+16} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">Optical — Elliptical Reflector</text>
          {(() => {
            const ocx=252, ocy=row2+70, oa=58, ob=34, oc=Math.sqrt(oa*oa-ob*ob);
            const pts=[];
            for(let t=-Math.PI;t<=0;t+=0.05) pts.push((ocx+oa*Math.cos(t))+','+(ocy-ob*Math.sin(t)));
            return (
              <g>
                <path d={"M "+pts.join(' L ')} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="2"/>
                <line x1={ocx-oa} y1={ocy} x2={ocx+oa} y2={ocy} stroke="#2E75B6" strokeWidth="1" strokeDasharray="3,3"/>
                <circle cx={ocx-oc} cy={ocy} r={5} fill="#e07b00"/>
                <circle cx={ocx+oc} cy={ocy} r={5} fill="#c0392b"/>
                {(() => {
                  const t=-Math.PI/3;
                  const rx=ocx+oa*Math.cos(t), ry=ocy-ob*Math.sin(t);
                  return (
                    <g>
                      <line x1={ocx-oc} y1={ocy} x2={rx} y2={ry} stroke="#e07b00" strokeWidth="1.5"/>
                      <line x1={rx} y1={ry} x2={ocx+oc} y2={ocy} stroke="#c0392b" strokeWidth="1.5"/>
                    </g>
                  );
                })()}
                <text x={ocx-oc} y={ocy+14} textAnchor="middle" fontSize="8" fill="#e07b00">F1</text>
                <text x={ocx+oc} y={ocy+14} textAnchor="middle" fontSize="8" fill="#c0392b">F2</text>
              </g>
            );
          })()}
          <text x={252} y={row2+pH-10} textAnchor="middle" fontSize="9" fill="#555">Rays from F1 always reach F2</text>

          {/* ── Chemical: Reactor Vessel ── */}
          <rect x={340} y={row2} width={170} height={pH} rx={5} fill="#fff" stroke="#ccd9ea"/>
          <text x={425} y={row2+16} textAnchor="middle" fontSize="10" fill="#1F3864" fontWeight="700">Chemical — Reactor Vessel</text>
          {(() => {
            const vcx=425, vcy=row2+72, vR=40;
            return (
              <g>
                <ellipse cx={vcx} cy={vcy-30} rx={vR} ry={11} fill="#d0e8ff" stroke="#2E75B6" strokeWidth="1.5"/>
                <rect x={vcx-vR} y={vcy-30} width={vR*2} height={46} fill="#d0e8ff" stroke="#2E75B6" strokeWidth="1.5"/>
                <ellipse cx={vcx} cy={vcy+16} rx={vR} ry={11} fill="#b0d8ff" stroke="#2E75B6" strokeWidth="1.5"/>
                <line x1={vcx} y1={vcy-30-11} x2={vcx} y2={vcy+16} stroke="#1F3864" strokeWidth="2"/>
                <line x1={vcx-20} y1={vcy-8} x2={vcx+20} y2={vcy-8} stroke="#1F3864" strokeWidth="3"/>
                <text x={vcx} y={vcy+32} textAnchor="middle" fontSize="8" fill="#555">A = πr²  V = πr²h</text>
              </g>
            );
          })()}
          <text x={425} y={row2+pH-10} textAnchor="middle" fontSize="9" fill="#555">Cylindrical geometry throughout</text>
        </svg>
      </div>
      <div style={S.dCaption}>
        Circles and ellipses appear across every engineering discipline. The ellipse's focal property is the basis for reflectors (optical, acoustic) and orbital mechanics. The circle defines pipes, shafts, pressure vessels, and Mohr's circle for stress analysis.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// MAIN COMPONENT
// ─────────────────────────────────────────────────────────────────
export default function CirclesAndEllipses(props) {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Circles and Ellipses</h1>

      <p style={S.p}>
        Circles and ellipses are the two most common curved shapes in engineering. A circle is the special case of an ellipse where both axes are equal. Together they describe cross-sections, orbits, stress states, reflectors, and wave patterns across every engineering discipline.
      </p>

      <InfoBox
        title="Circle: all points equidistant from center.  Ellipse: all points where r₁ + r₂ = constant."
        items={[
          "Circle — standard form: (x-h)² + (y-k)² = r²   center (h,k), radius r",
          "Ellipse — standard form: x²/a² + y²/b² = 1   semi-major a, semi-minor b  (a > b)",
          "Relationship: c² = a² - b²  where c is the focal distance from center to each focus",
          "Eccentricity e = c/a: e=0 → circle, 0<e<1 → ellipse, e=1 → parabola, e>1 → hyperbola",
        ]}
      />

      <h2 style={S.h2}>Circle Anatomy</h2>
      <DiagramCircleAnatomy />
      <Table2 rows={[
        ["Radius r",          "Distance from center to any point on the circle\nAll radii of the same circle are equal"],
        ["Diameter d",        "d = 2r — longest chord, passes through center"],
        ["Circumference C",   "C = 2πr = πd — distance around the circle"],
        ["Area A",            "A = πr²"],
        ["Chord",             "Line segment connecting two points on the circle\nChord length = 2r·sin(θ/2) where θ is the central angle"],
        ["Arc length s",      "s = rθ  (θ must be in radians)\nFraction of circumference: s = (θ/2π)·2πr"],
        ["Sector area",       "A = r²θ/2  (θ in radians)\nFraction of total area: A = (θ/2π)·πr²"],
        ["Tangent line",      "Touches circle at exactly one point\nAlways perpendicular to the radius at that point"],
        ["Central angle",     "Angle at the center subtended by an arc\nInscribed angle = half the central angle for the same arc"],
      ]} />

      <h2 style={S.h2}>Circle Equations</h2>
      <DiagramCircleEquations />
      <Table2 rows={[
        ["Standard form",     "(x-h)² + (y-k)² = r²\nCenter at (h, k), radius r — read off directly"],
        ["General form",      "x² + y² + Dx + Ey + F = 0\nCenter: (-D/2, -E/2),  r = sqrt((D/2)²+(E/2)²-F)"],
        ["Completing square", "Group x terms and y terms separately\nAdd (D/2)² and (E/2)² to both sides\nFactor each group as a perfect square"],
        ["Unit circle",       "x² + y² = 1  (center at origin, r=1)\nAny point: (cosθ, sinθ) — the foundation of trigonometry"],
        ["3 points → circle", "Any three non-collinear points define a unique circle\nSolve the system by substituting each point into general form"],
      ]} />

      <h2 style={S.h2}>Degrees, Radians, and Arc Length</h2>
      <DiagramRadians />
      <Table2 rows={[
        ["Radian definition",  "1 radian = angle that subtends an arc equal to the radius\n2π radians = 360°  →  1 radian ≈ 57.296°"],
        ["Conversion",         "Degrees to radians: multiply by π/180\nRadians to degrees: multiply by 180/π"],
        ["Arc length",         "s = rθ  (θ in radians)\nOnly works in radians — convert first if given degrees"],
        ["Sector area",        "A = r²θ/2 = (1/2)·r·s  (θ in radians)"],
        ["Angular velocity",   "ω in radians per second — standard engineering unit\n1 revolution per second = 2π rad/s\nConvert RPM: ω = RPM × 2π/60"],
        ["Why radians",        "Derivatives of sin and cos only equal cos and -sin when angles are in radians\nAll calculus-based formulas assume radians"],
      ]} />

      <h2 style={S.h2}>Ellipse Anatomy</h2>
      <DiagramEllipseAnatomy />
      <Table2 rows={[
        ["Standard form",      "x²/a² + y²/b² = 1  (center at origin, major axis horizontal)\ny²/a² + x²/b² = 1  (major axis vertical)\na = semi-major axis, b = semi-minor axis, a > b"],
        ["Focal distance c",   "c² = a² - b²\nc = distance from center to each focus"],
        ["Eccentricity e",     "e = c/a  (0 ≤ e < 1 for an ellipse)\ne close to 0 → nearly circular\ne close to 1 → very elongated"],
        ["Defining property",  "For any point P on the ellipse: PF₁ + PF₂ = 2a\nSum of distances to both foci is constant"],
        ["Area",               "A = πab  (analogous to πr² with both radii)"],
        ["Perimeter",          "No simple exact formula — Ramanujan approximation:\nP ≈ π[3(a+b) - sqrt((3a+b)(a+3b))]"],
        ["Shifted ellipse",    "(x-h)²/a² + (y-k)²/b² = 1  — center at (h,k)"],
        ["Parametric form",    "x(t) = h + a·cos(t)\ny(t) = k + b·sin(t)  (t from 0 to 2π)"],
      ]} />

      <h2 style={S.h2}>Inscribed and Circumscribed Circles</h2>
      <DiagramInscribed />
      <Table2 rows={[
        ["Circumscribed circle","Circumcircle — passes through all vertices of a polygon\nCircumradius R = a/(2sinA) for a triangle (law of sines)"],
        ["Inscribed circle",   "Incircle — tangent to all sides of a polygon\nInradius r = Area / semi-perimeter for a triangle"],
        ["Equilateral triangle","R = s/√3,  r = s/(2√3) = R/2\nR = 2r for any equilateral triangle"],
        ["Bolt circle (BCD)",  "Bolt Circle Diameter — circle on which bolt holes are centered\nBolt spacing angle = 360°/n\nChord between adjacent bolts = BCD·sin(π/n)"],
        ["Pitch circle",       "Gear teeth are measured at the pitch circle diameter (PCD)\nModule m = PCD/number of teeth"],
        ["Engineering use",    "Bolt patterns, gear geometry, pipe fittings, flange design,\nshaft-hub fits, bearing seat diameters"],
      ]} />

      <h2 style={S.h2}>Engineering Applications</h2>
      <DiagramApplications />

      <InfoBox
        title="Key Takeaway — Where Circles and Ellipses Appear Across Engineering"
        items={[
          "Civil/Structural: pipe cross-sections (annular area A = π(R²-r²)), Mohr's circle for finding principal stresses and max shear.",
          "Aerospace: planetary orbits and satellite trajectories are ellipses with the central body at one focus (Kepler's first law).",
          "Electrical: two sinusoids of different phase plotted against each other trace an ellipse on an oscilloscope (Lissajous figure).",
          "Optical/Acoustic: elliptical reflectors redirect all energy from one focus to the other — used in medical lithotripsy, concert halls, and antennas.",
          "Chemical/Process: cylindrical vessels, tanks, and reactors — all circular cross-sections, volume = πr²h.",
          "Mechanical: bolt circle patterns, gear pitch circles, cam profiles, and shaft/bearing fits all use circle geometry directly.",
        ]}
      />
    </div>
  );
}